<template>
	<div class="template_input">
		<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
		<input type="date" id="params.name" v-model="startDate" v-bind:min="minDate">
	</div>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'date_input',
	data() {
		return {
			startDate : ''
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
		minDate : function() {
			let currDate = new Date();
			let minDate = lib.dateToInput(currDate);
			this.startDate = minDate; //Works cause computed properties are cached by Vue.js
			return minDate;
		}
	},
	methods : {
		validate : function(v) {
			return v.trim().length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel
	},
	watch: {
		startDate : function(val){
			this.notifyUpdate(val);
		},
		oldValue : function(val){
			if(!val) {
				this.startDate = this.minDate;
				this.notifyUpdate(this.startDate);
			}

		}
	},
	mounted : function(){
		if(this.oldValue) this.startDate = this.oldValue;
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/date_input.vue